import { render, staticRenderFns } from "./addpro.vue?vue&type=template&id=04c5af29&"
import script from "./addpro.vue?vue&type=script&lang=js&"
export * from "./addpro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports